import { preloadExternalShare } from '@confluence/external-share/entry-points/preloadExternalShare.ts';
import { expVal } from '@confluence/feature-experiments';
import { createDataFetcherForSuspense } from '@confluence/query-preloader-tools/entry-points/dataFetcherForSuspense.ts';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';
import { preloadPlatformNavigationQuery } from '@confluence/side-navigation/entry-points/preloadPlatformNavigationQuery.ts';
import { preloadInvitedAppShortcutsRecommendationsQuery } from '@confluence/side-navigation/entry-points/preloadInvitedAppShortcutsRecommendationsQuery.ts';
import { preloadSpacesList } from '@confluence/space-utils/entry-points/preloadSpacesList.ts';
import { fg } from '@confluence/feature-gating';

export const preloadAccessLinkRoute = (match: RouteMatch): Promise<void | Error[] | unknown[]> => {
	const tasks: Promise<unknown>[] = [];

	if (expVal('shareable_links_m0', 'isEnabled', false)) {
		tasks.push(
			preloadExternalShare({
				shareToken: match.params.shareToken,
			}),
		);
	}

	const { accessStatus } = getPreloaderFnContext();
	const isLicensed =
		accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS ||
		accessStatus === AccessStatus.LICENSED_USE_ACCESS;

	if (isLicensed) {
		tasks.push(
			createDataFetcherForSuspense('side-navigation', () => {
				const sideNavTasks = [preloadSpacesList({ isLicensed })];
				if (fg('navx-global-side-nav-confluence')) {
					sideNavTasks.push(preloadPlatformNavigationQuery());
					// Self-gates on the productionisation gate + experiment; no-ops for non-cohort users.
					sideNavTasks.push(preloadInvitedAppShortcutsRecommendationsQuery());
				}
				return sideNavTasks;
			}),
		);
	}

	return waitForAllReturnWhenError(tasks);
};
